export { TableDetails } from './TableDetails';
